// External imports
import { Component } from '@angular/core';

// Global imports

// Local imports
import { AuthenticationService } from '../../services/auth';
import { GlobalStateService } from '../../services/state/global-state';

@Component({
	selector: 'rb-root',
	template: `
		<rb-load-indicator [show]="isGlobalStateLoading">
			<rb-navbar />
			<router-outlet />
		</rb-load-indicator>
		<ibm-placeholder />
	`,
	standalone: false,
})
export class RootComponent {
	isGlobalStateLoading: boolean = false;

	constructor(authService: AuthenticationService, globalStateService: GlobalStateService) {
		authService.userLoggedInObservable.subscribe(async (userLoggedIn) => {
			if (!userLoggedIn) {
				globalStateService.clearState();
			}
		});
		globalStateService
			.getInitializingObservable()
			.subscribe((initializing) => (this.isGlobalStateLoading = initializing));
	}
}
